
export interface ShopValidation {
  id: string;
  name: string;
  permalink: string;
  warnings: string[];
}
